import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { ProcessedPricingData } from 'src/providers/pricing/PricingWebsocketClient';
import { publishMarketLiveUpdate } from '../marketLiveStateCore';

/**
 * The pricing-websocket transport adapter for the market live-state module's
 * write seam. Publishes oracle + mark prices from the Data-API pricing
 * websocket (PricingSubscriptionProvider) into `publishMarketLiveUpdate`.
 *
 * The Data-API carries a chain slot for both prices (`oraclePriceSlot` /
 * `markPriceSlot`), so pricing-ws competes head-to-head with the DLOB and RPC
 * transports on slot in `selectNewestSnapshot`.
 */
export const publishPricingWsBatch = (batch: ProcessedPricingData[]): void => {
	for (const item of batch) {
		const marketId = new MarketId(item.marketIndex, item.marketType);

		publishMarketLiveUpdate('pricing-ws', marketId, {
			oracle: {
				price: BigNum.fromPrint(
					item.oraclePrice.toString(),
					PRICE_PRECISION_EXP
				),
				slot: item.oraclePriceSlot,
			},
			mark: {
				price: BigNum.fromPrint(item.markPrice.toString(), PRICE_PRECISION_EXP),
				slot: item.markPriceSlot,
			},
		});
	}
};
